import { IconSVG } from '../types';

export const ContactSupport = ({ size, style }: IconSVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 40 40"
    style={style}
  >
    <mask
      id="mask0_4013_5956"
      style={{ maskType: 'alpha' }}
      width="60"
      height="60"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H40V40H0z" />
    </mask>
    <g mask="url(#mask0_4013_5956)">
      <path
        fill="currentColor"
        d="M20 36.667l-.417-5h-.416c-3.945 0-7.292-1.375-10.042-4.125S5 21.444 5 17.5s1.375-7.292 4.125-10.042 6.097-4.125 10.042-4.125c1.972 0 3.812.368 5.52 1.104a14.309 14.309 0 017.542 7.542c.736 1.708 1.104 3.549 1.104 5.52 0 2.084-.34 4.084-1.02 6a21.232 21.232 0 01-2.792 5.334 23.606 23.606 0 01-4.209 4.459A26.085 26.085 0 0120 36.667zm3.333-6.084a20.753 20.753 0 004.813-5.854C29.382 22.493 30 20.083 30 17.5c0-3.027-1.049-5.59-3.146-7.687-2.097-2.097-4.66-3.145-7.687-3.145-3.028 0-5.59 1.048-7.688 3.145-2.097 2.098-3.146 4.66-3.146 7.688 0 3.028 1.049 5.59 3.146 7.687 2.097 2.098 4.66 3.146 7.688 3.146h4.166v2.25zm-4.208-3.958c.472 0 .875-.167 1.208-.5.334-.333.5-.736.5-1.208 0-.473-.166-.875-.5-1.209a1.646 1.646 0 00-1.208-.5c-.472 0-.875.167-1.208.5-.334.334-.5.736-.5 1.209 0 .472.166.875.5 1.208.333.333.736.5 1.208.5zm-1.208-5.292h2.5c0-.833.083-1.416.25-1.75.166-.333.694-.944 1.583-1.833.5-.5.917-1.042 1.25-1.625.333-.583.5-1.208.5-1.875 0-1.417-.48-2.48-1.438-3.188-.958-.708-2.09-1.062-3.395-1.062-1.223 0-2.25.34-3.084 1.02-.833.681-1.416 1.508-1.75 2.48l2.334.917c.139-.473.402-.938.791-1.396.39-.459.959-.688 1.709-.688.75 0 1.312.209 1.687.625.375.417.563.875.563 1.375 0 .473-.14.896-.417 1.271-.278.375-.611.757-1 1.146-.972.833-1.563 1.493-1.77 1.98-.21.485-.313 1.353-.313 2.603z"
      />
    </g>
  </svg>
);
